import { Component } from "react";
import CONSULT_CASHCLOSING from "../../component_bank/cashclosing/cashclosing/consult_cashclosing";

export class SetBanc extends Component {
  

  render() {
    return (
      <div className="tc">
        <CONSULT_CASHCLOSING />
      </div>
    );
  }
}

export default SetBanc;
